export default {
  simulationDataIsMissing: 'Prosím vyplňte materiál a vyberte výpočtový model',
  errorMinLargerMax: 'min > max',
};
